'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

var _noop = require('lodash/noop');

var _noop2 = _interopRequireDefault(_noop);

var _getStyles = require('./get-styles');

var _getStyles2 = _interopRequireDefault(_getStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  /** MessageList content */
  children: _propTypes2.default.node.isRequired,
  /** The amount of pixels the user has to scroll up to disable auto scroll */
  scrollOffset: _propTypes2.default.number,
  /** Reference list element */
  listRef: _propTypes2.default.func,
  /** Override the styles of the root element */
  style: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Override the styles of the ul element */
  listStyle: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
  /** Enable autoScroll */
  autoScroll: _propTypes2.default.bool
};

var defaultProps = {
  scrollOffset: 100,
  listRef: _noop2.default,
  style: {},
  listStyle: {},
  autoScroll: false
};

var displayName = 'MessageList';

/** Render a list of items (Messages) with optional auto scroll */

var MessageList = function (_Component) {
  _inherits(MessageList, _Component);

  function MessageList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MessageList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MessageList.__proto__ || Object.getPrototypeOf(MessageList)).call.apply(_ref, [this].concat(args))), _this), _this.setRef = function (node) {
      var listRef = _this.props.listRef;


      _this.messageList = node;

      listRef(node);
    }, _this.scrollToBottom = function () {
      var scrollHeight = _this.messageList.scrollHeight;


      _this.messageList.scrollTop = scrollHeight;
    }, _this.shouldScrollToBottom = function (_ref2) {
      var scrollHeight = _ref2.scrollHeight,
          scrollTop = _ref2.scrollTop,
          offsetHeight = _ref2.offsetHeight;
      var scrollOffset = _this.props.scrollOffset;


      var position = scrollHeight - (scrollTop + offsetHeight);

      return position < scrollOffset;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MessageList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      var autoScroll = this.props.autoScroll;


      if (autoScroll) {
        this.shouldScroll = this.shouldScrollToBottom(this.messageList);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var autoScroll = this.props.autoScroll;


      if (autoScroll && this.shouldScroll) {
        this.scrollToBottom();

        this.shouldScroll = false;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          style = _props.style,
          listStyle = _props.listStyle,
          listRef = _props.listRef,
          scrollOffset = _props.scrollOffset,
          autoScroll = _props.autoScroll,
          custom = _objectWithoutProperties(_props, ['children', 'style', 'listStyle', 'listRef', 'scrollOffset', 'autoScroll']);

      return _react2.default.createElement(
        'article',
        _extends({ style: _getStyles2.default.root(style) }, custom),
        _react2.default.createElement(
          'ul',
          { style: _getStyles2.default.list(listStyle), ref: this.setRef },
          children
        )
      );
    }
  }]);

  return MessageList;
}(_react.Component);

MessageList.propTypes = propTypes;
MessageList.defaultProps = defaultProps;
MessageList.displayName = displayName;

exports.default = (0, _radium2.default)(MessageList);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/anchor-ui/message-list/index.js
// module id = 817
// module chunks = 0